import { render, staticRenderFns } from "./DropImages.vue?vue&type=template&id=51900a2d&scoped=true&"
import script from "./DropImages.vue?vue&type=script&lang=js&"
export * from "./DropImages.vue?vue&type=script&lang=js&"
import style0 from "./DropImages.vue?vue&type=style&index=0&id=51900a2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51900a2d",
  null
  
)

export default component.exports